export enum PortalIds {
  App = 'app-portal',
}
